<img [alt]="alt()" draggable="false" [defaultImage]="defaultImage()" [lazyLoad]="src">